import { getIsUngatedForInbound25 } from 'pricing-pages-lib/utils/gatingUtils';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { NavItemEnum, SegmentedNavItems, SegmentedNavItemsWithDataHub } from '../constants/routing/NavItems';
const productLineToNavItemMap = {
  [CMS]: NavItemEnum.CONTENT,
  [MARKETING]: NavItemEnum.MARKETING,
  [OPERATIONS]: NavItemEnum.OPERATIONS,
  [SALES]: NavItemEnum.SALES,
  [SERVICE]: NavItemEnum.SERVICE,
  [COMMERCE]: NavItemEnum.COMMERCE
};
export const getNavItemForProductLine = (state, productLine) => {
  if (productLine === OPERATIONS && getIsUngatedForInbound25(state)) {
    return NavItemEnum.DATA;
  }
  return productLineToNavItemMap[productLine];
};
export const getSegmentedNavItems = state => {
  if (getIsUngatedForInbound25(state)) {
    return SegmentedNavItemsWithDataHub;
  }
  return SegmentedNavItems;
};
export const getProductLineForNavItem = navItem => {
  switch (navItem) {
    case NavItemEnum.MARKETING:
      return MARKETING;
    case NavItemEnum.SALES:
      return SALES;
    case NavItemEnum.SERVICE:
      return SERVICE;
    case NavItemEnum.CMS:
    case NavItemEnum.CONTENT:
      return CMS;
    case NavItemEnum.OPERATIONS:
    case NavItemEnum.DATA:
      return OPERATIONS;
    // TODO: [Pre-Inbound] Handle commerce when it's available
    // case NavItemEnum.COMMERCE:
    //   return COMMERCE;
    default:
      return null;
  }
};